var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('vs-chip',{staticStyle:{"font-size":"large","font-weight":"700"},attrs:{"color":"success"}},[_vm._v("\n\t\n    "+_vm._s(_vm.VALUE)+"\n  ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }